import Link from 'next/link'

import { styled } from '@mui/material/styles'

export const Root = styled(Link)(({ theme }) => ({
  color: theme.palette.primary[800],

  ':visited': {
    color: theme.palette.primary[800],
  },
}))
